import { LoggerBus } from '@app/utils/logger-bus';
import { hostFactory as hostInstance } from "../factory";

const loggerFormat = '[api::my::training]';

const schedule = () => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/my/schedule`);
}

const program = () => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/my/program`);
}

const records = ({date, version}) => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/my/records`, { params: {date, version} });
}

const recordsDownload = (data) => {
    LoggerBus.$log.debug(loggerFormat);
    const opts = {
        responseType: 'arraybuffer',
        params: data
    };

    return hostInstance.get(`/api/my/records/download`, opts);
}

const recordScore = (registrationId, scoreId) => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/records/registrations/${registrationId}/scores/${scoreId}`);
}

const certificate = (certificateHash) => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/my/certificates/${certificateHash}`);
}

const certificateDownload = (certificateHash) => {
    LoggerBus.$log.debug(loggerFormat);
    const opts = {
        responseType: 'arraybuffer'
    };
    return hostInstance.get(`/api/my/certificates/${certificateHash}/download`, opts);
}

const training = () => {
    LoggerBus.$log.debug(loggerFormat);
    return hostInstance.get(`/api/my/training`);
}

export default { schedule, program, records, recordsDownload, recordScore, certificate, certificateDownload, training };
